"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Checkbox = _interopRequireDefault(require("../Input/CheckBox/Checkbox"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _DropDownMenu = _interopRequireWildcard(require("../DropDownMenu/DropDownMenu"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./WGResourceItem.scss");

require("./WGResourceItemDark.scss");

var _reactstrap = require("reactstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var WGResourceItem = function WGResourceItem(_ref) {
  var idCheck = _ref.idCheck,
      label = _ref.label,
      disabledCheck = _ref.disabledCheck,
      selected = _ref.selected,
      onEdit = _ref.onEdit,
      onDelete = _ref.onDelete,
      onAssociations = _ref.onAssociations,
      onClickedChange = _ref.onClickedChange,
      campaignType = _ref.campaignType,
      iconSrc = _ref.iconSrc,
      clicked = _ref.clicked,
      labelCampaignType = _ref.labelCampaignType,
      labelButtonClicked = _ref.labelButtonClicked,
      labelButtonNotClicked = _ref.labelButtonNotClicked,
      labelEdit = _ref.labelEdit,
      labelAssociations = _ref.labelAssociations,
      labelDelete = _ref.labelDelete,
      titleLabel = _ref.titleLabel,
      disabled = _ref.disabled,
      warning = _ref.warning,
      labelRemove = _ref.labelRemove,
      onRemove = _ref.onRemove;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var refTooltip = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-WGResource-item ".concat(clicked ? 'clicked' : '', " ").concat(selected ? 'selected' : '', " ").concat(checked ? 'checked' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-WGResource-item-title'
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    id: idCheck,
    checked: checked,
    disabled: disabledCheck,
    onChange: setChecked,
    assigned: clicked
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-WGResource-icon ".concat(campaignType == '0' ? 'inbound' : 'outbound')
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + iconSrc
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-WGResource-item-campaign"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-WGResource-item-campaign-label"
  }, titleLabel), /*#__PURE__*/_react["default"].createElement("span", {
    ref: refTooltip
  }, label), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "top",
    target: refTooltip,
    autohide: false,
    trigger: 'hover'
  }, label))), /*#__PURE__*/_react["default"].createElement("span", {
    className: "glc-campaign-type"
  }, labelCampaignType), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-WGResource-item-btns ".concat(selected && 'selected', " ")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-WGResource-item-warning ".concat(warning && 'show')
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon info",
    id: 'gcl-WGResource-item-btns' + idCheck
  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    delay: {
      show: 500,
      hide: 100
    },
    placement: "top",
    target: 'gcl-WGResource-item-btns' + idCheck
  }, warning)), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    toggle: true,
    onClick: onClickedChange,
    active: clicked,
    disabled: disabled
  }, clicked ? labelButtonNotClicked : labelButtonClicked), /*#__PURE__*/_react["default"].createElement(_DropDownMenu["default"], null, onEdit != null && /*#__PURE__*/_react["default"].createElement(_DropDownMenu.Option, {
    onClick: function onClick() {
      onEdit({
        id: idCheck,
        campaignType: campaignType
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon edit"
  }), labelEdit), /*#__PURE__*/_react["default"].createElement(_DropDownMenu.Option, {
    onClick: onAssociations
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon association"
  }), labelAssociations), onRemove != null && /*#__PURE__*/_react["default"].createElement(_DropDownMenu.Option, {
    onClick: onRemove
  }, /*#__PURE__*/_react["default"].createElement("i", {
    "class": "gcl-icon rounded-arrow"
  }), labelRemove), onDelete != null && /*#__PURE__*/_react["default"].createElement(_DropDownMenu.Option, {
    onClick: function onClick() {
      onDelete({
        id: idCheck,
        campaignType: campaignType
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon trash"
  }), labelDelete))));
};

WGResourceItem.propTypes = {
  idCheck: _propTypes["default"].isRequired,
  label: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  disabledCheck: _propTypes["default"].bool,
  selected: _propTypes["default"].bool,
  onCheckChange: _propTypes["default"].func,
  onEdit: _propTypes["default"].func,
  onDelete: _propTypes["default"].func,
  onClickedChange: _propTypes["default"].func,
  onAssociations: _propTypes["default"].func,
  campaignType: _propTypes["default"].string,
  iconSrc: _propTypes["default"].string,
  clicked: _propTypes["default"].bool,
  labelCampaignType: _propTypes["default"].string,
  labelButtonClicked: _propTypes["default"].string,
  labelButtonNotClicked: _propTypes["default"].string,
  labelEdit: _propTypes["default"].string,
  labelDelete: _propTypes["default"].string,
  labelAssociations: _propTypes["default"].string,
  titleLabel: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  warning: _propTypes["default"].string
};
WGResourceItem.defaultProps = {
  disabledCheck: false,
  selected: false,
  onCheckChange: function onCheckChange() {},
  onAssociations: function onAssociations() {},
  onClickedChange: function onClickedChange() {},
  campaignType: '1',
  iconSrc: '',
  clicked: false,
  labelCampaignType: '',
  labelButtonClicked: 'Assign',
  labelButtonNotClicked: 'Unassign',
  labelEdit: 'Edit',
  labelDelete: 'Delete',
  labelAssociations: 'Associations',
  titleLabel: '',
  disabled: false,
  warning: null
};
var _default = WGResourceItem;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/WGResourceItem/WGResourceItem.js
// module id = 1936
// module chunks = 0